module.exports = __webpack_public_path__ + "static/AkkuratPro-Bold-b5cb7e8a833e7086ebab55a0ca3f8452.woff";